import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { Button,Popconfirm, message  } from "antd"
import { useDispatch } from "react-redux"
import { editVideo, toggleModal } from "../../../features/videos/videosSlice";
import { useDeleteVideoMutation } from "../../../features/videos/videosApi";
import { useEffect } from "react";

export default function VideoRow({ video,setOpen }) {
  const dispatch = useDispatch();
  const { id, title, url, views, duration, createdAt, description } = video || {}

  const [deleteVideo, {isLoading, isError, error}] = useDeleteVideoMutation()
  const deleteHander = () => {
    console.info('delete confirmed')
    deleteVideo(video?.id)
  }

  useEffect(()=>{
    if(isError){
      const msg = typeof error?.data =='string' ? error?.data : 'Internal server error'
      message.error(msg)
    }
  },[error, isError])

  const editHandler = ()=>{
    dispatch(editVideo(video))
    dispatch(toggleModal(true))
  }
  return (
    <tr>
      <td className="table-td max-w-sm truncate">
        {title}
      </td>
      <td className="table-td max-w-md truncate">
        {description}
      </td>
      <td className="table-td ">
          <Popconfirm
            title="Delete the video"
            description="Are you sure to delete this video?"
            okText="Yes"
            cancelText="No"
            onConfirm={deleteHander}
          >
            <Button type="link" danger><DeleteOutlined /></Button>
          </Popconfirm>
          <Button type="link" onClick={editHandler}><EditOutlined /></Button>
      </td>
    </tr>
  )
}